
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ToolContainer } from "../../contents";
import { IDocumentImageSource } from "../../../../../domain/document";
import PaneMixin from "./PaneMixin.vue";

@Component({
  components: {
    ToolContainer,
  }
})
export default class MainToolContainablePaneMixin extends Mixins(PaneMixin) {
  get tabs(): any[] {
    return [
      ToolContainer.Tabs.edit,
      ToolContainer.Tabs.fixedPhrase,
      this.isClaioRestricted ? null : ToolContainer.Tabs.claio,
      this.isClaioSchemaRestricted ? null : ToolContainer.Tabs.claioSchema,
      ToolContainer.Tabs.clipboard,
      ToolContainer.Tabs.pastData,
      this.isExternalImageRestricted ? null : ToolContainer.Tabs.externalImage,
      this.isOcojoRestricted ? null : ToolContainer.Tabs.ocojo,
      ToolContainer.Tabs.aiPhrase,
    ];
  }

  get maxWidth(): number {
    return this.$configuration.behavior.document.editor.panes.left.maxWidth;
  }

  get defaultSelectedTab(): any {
    if (this.defaultToolTabName && (this.defaultToolTabName in ToolContainer.Tabs)) {
      return ToolContainer.Tabs[this.defaultToolTabName];
    }
    return this.$configuration.behavior.document.editor.panes.left.defaultSelectedTab in ToolContainer.Tabs
           ? ToolContainer.Tabs[this.$configuration.behavior.document.editor.panes.left.defaultSelectedTab]
           : null;
  }

  @Prop()
  defaultToolTabName: string;

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  get isToolsRestricted(): boolean {
    return this.editingSource
      && this.editingSource.restrictions
      && !!this.editingSource.restrictions.tools;
  }

  get isClaioRestricted(): boolean {
    return this.isToolsRestricted 
      && this.editingSource.restrictions.tools.claio.isDisabled;
  }

  get isClaioSchemaRestricted(): boolean {
    return this.isToolsRestricted 
      && this.editingSource.restrictions.tools.claioSchema.isDisabled;
  }

  get isExternalImageRestricted(): boolean {
    return this.isToolsRestricted 
      && this.editingSource.restrictions.tools.externalImage.isDisabled;
  }

  get isOcojoRestricted(): boolean {
    return this.isToolsRestricted 
      && this.editingSource.restrictions.tools.ocojo.isDisabled;
  }
}
